import React from "react";
import InvoiceState from "../interface/invoiceState";
import {get} from "lodash";
import InvoiceRepository from "../repository/invoiceRepository";
import AppOrdersController from "../../Main/controller/AppOrdersController";
import MarketOrderLocalstorage from "../../Main/interface/MarketOrderLocalstorage";
import LocalStorageRepository from "../../../repository/LocalStorageRepository";
import i18n from "../../../i18n";

export default class InvoiceController {
    protected state: InvoiceState;
    protected setState: React.Dispatch<React.SetStateAction<InvoiceState>>;

    constructor(state: InvoiceState, setState: React.Dispatch<React.SetStateAction<InvoiceState>>) {
        this.state = state;
        this.setState = setState;
    }

    getDeskName() {
        if (this.state.deskActive?.id) {
            return get(this.state.deskActive, "label", "").trim()
        }

        return i18n.t("invoice.takeout")
    }

    backToSelectDesk() {
        this.setState({takeaway: false, deskActive: undefined, loading: false});
    }

    static filterDesks(search: string, desks?: { label: string, id: string, date: Date }[]) {
        if (!desks?.length) return [];
        return search
            ? desks.filter(item => item.label.toLowerCase().includes(search.toLowerCase()))
            : desks;
    }

    static async setOrderServer() {
        const waiting = LocalStorageRepository.get("waiting") as string
        if (JSON.parse(waiting)) return null;

        LocalStorageRepository.set("waiting", true)

        const now = new Date().toLocaleDateString(i18n.language === 'ar-IQ' ? 'ar-IQ' : 'fa-IR');
        const orders = AppOrdersController.getSetting() as MarketOrderLocalstorage[];
        if (!orders.length) {
            LocalStorageRepository.set("waiting", false);
            return false;
        }

        orders.map(async (order) => {
            const res = await InvoiceRepository.orderSet(order.shopId, order.price, {
                products: order.order.products,
                payAt: now,
                rrn: order.order.rrn,
                trace: order.order.trace,
            }, order.desk)

            if (get(res, "status", false)) {
                AppOrdersController.deleteOrder(order)
                LocalStorageRepository.set("retryCount", "0");
            } else {
                const current = parseInt(localStorage.getItem("retryCount") || "0");
                LocalStorageRepository.set("retryCount", (current + 1).toString());
            }
        })

        LocalStorageRepository.set("waiting", false)
    }
}